import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import styles from "./ResetPassword.module.css";
import AuthCustomerModal from "../components/AuthCustomerModal";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [tokenValid, setTokenValid] = useState(true);
  const [showLoginModal, setShowLoginModal] = useState(false);

  // Перевірка токена при завантаженні сторінки
  useEffect(() => {
    if (!token) {
      setTokenValid(false);
      return;
    }
    const verifyToken = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/customers/verify-reset-token?token=${token}`
        );
        if (!res.ok) {
          setTokenValid(false);
        }
      } catch {
        setTokenValid(false);
      }
    };
    verifyToken();
  }, [token]);

const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");

  if (password !== confirmPassword) {
    setError("Паролі не співпадають.");
    return;
  }

  setLoading(true);
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/customers/reset-password`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
        credentials: "include", // 🔹 щоб бекенд міг поставити cookie
      }
    );

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data?.message || "Не вдалося оновити пароль.");
    }

    // 🔹 зберігаємо новий токен у localStorage
    if (data?.token) {
      localStorage.setItem("token", data.token);
    }

    setSuccess(true);

    // Показуємо модальне вікно або можна одразу редіректнути
    setTimeout(() => {
      setShowLoginModal(true);
    }, 1500);
  } catch (err) {
    setError(err.message || "Сталася помилка.");
  } finally {
    setLoading(false);
  }
};

  if (!tokenValid) {
    return (
      <div className={styles.container}>
        <div className={styles.modalWindow}>
          <h1 className={styles.formTitle}>Посилання недійсне</h1>
          <p className={styles.error}>
            Це посилання для відновлення паролю прострочене або вже використане.
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.modalWindow}>
          <h1 className={styles.formTitle}>Встановлення нового паролю</h1>

          {success ? (
            <div className={styles.successMessage}>
              Пароль успішно змінено! Ви можете увійти у свій кабінет.
              <div className={styles.switchLine}>
                <span
                  className={styles.link}
                  onClick={() => {
                    window.location.href = window.location.origin;
                  }}
                >
                  Повернутися
                </span>
              </div>
            </div>
          ) : (
            <form className={styles.form} onSubmit={handleSubmit}>
              <div className={styles.field}>
                <label htmlFor="password">Новий пароль</label>
                <input
                  className={styles.input}
                  id="password"
                  name="password"
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                />
              </div>

              <div className={styles.field}>
                <label htmlFor="confirmPassword">Підтвердіть пароль</label>
                <input
                  className={styles.input}
                  id="confirmPassword"
                  name="confirmPassword"
                  type="password"
                  required
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  disabled={loading}
                />
              </div>

              {error && <div className={styles.error}>{error}</div>}

              <button
                className={styles.submit}
                type="submit"
                disabled={loading}
              >
                {loading ? "Збереження..." : "Зберегти пароль"}
              </button>
            </form>
          )}
        </div>
      </div>

      {showLoginModal && <AuthCustomerModal onClose={() => navigate("/")} />}
    </>
  );
};

export default ResetPassword;
